import { Component, OnDestroy } from '@angular/core';
import { StockService } from 'app/sections/stocks/services/stock.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-export-excel',
  templateUrl: './export-excel.component.html',
  styleUrls: ['./export-excel.component.scss']
})
export class ExportExcelComponent implements OnDestroy {

  private _unsubscribeAll = new Subject();
  public loading: boolean = false;

  constructor(private stockService: StockService) { }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  /**
   * This funcation call stock API to get all the data and generate excel
   */
  exportExcel() {
    this.loading = true;
    this.stockService.getAllTickers().pipe(takeUntil(this._unsubscribeAll)).subscribe((response: TickerResponse) => {
      const { data } = response;
      let header = ['Company', 'Price', '%Change', 'Sentiment', 'Technical', 'Fundamental', 'Valuation', 'Macro', 'Short Term', 'Long Term', 'Favorability'];
      let excel_data: any[] = [[...header]];
      data.forEach((e) => {
        const percentageChange = Number((((Number(e.price) / Number(e.previousClose)) - 1) * 100).toFixed(2));
        let row = [e.ticker, e.price, percentageChange, e.sentiment, e.technical, e.fundamental, e.valuation, e.macro, e.shortTermConviction, e.longTermConviction, e.score];
        excel_data.push(row);
      })
      const worksheet = XLSX.utils.json_to_sheet(excel_data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      XLSX.writeFile(workbook, `comulative_stock_table${new Date().toISOString()}` + '.xlsx');
      this.loading = false;
    })
  }

}

interface TickerResponse {
  message: string;
  data: StockTicker[];
}

interface StockTicker {
  ticker: string;
  price: string;
  previousClose: string;
  sentiment: string;
  technical: string;
  fundamental: string;
  valuation: string;
  macro: string;
  shortTermConviction: string;
  longTermConviction: string;
  score: string;
}